// extracted by mini-css-extract-plugin
module.exports = {"mainLayout":"MainLayoutComponent_mainLayout__2cLHN"};